import { MouseEvent, ReactElement } from "react";
import { Color } from "../../../../utils/sys/Color";
import InventoryItemIconLibrary from "../../../../utils/sys/InventoryItemIconLibrary";
import { MutableRefObject } from "react";
import { useLongPress } from "../../../../common/hooks/LongPressHook";
import InventoryItemIcon from "../InventoryItemIcon/InventoryItemIcon";

import "./InteractiveInventoryItemIcon_style.css";

type Props = {
    bgSrc?: string | null;
    iconSrc?: string | null;
    bgColor?: Color | null;
    iconColor?: Color | null;
    highlightColor?: "active" | "valid" | "invalid" | null;
    onClick?: (e?: MouseEvent) => void;
    onLongClick?: (e?: MouseEvent) => void;
    className?: string;
    forwardRef?: MutableRefObject<any>;
};

export default function InteractiveInventoryItemIcon({
    bgSrc,
    iconSrc,
    bgColor,
    iconColor,
    highlightColor,
    onClick,
    onLongClick,
    className,
    forwardRef,
}: Props): ReactElement {
    const longClickTimeMS = 600;

    const [longPress, isPressing, isPressComplete] = useLongPress(
        longClickTimeMS,
        onLongClick,
        onClick
    );

    return (
        <div
            ref={forwardRef}
            className={`item-icon-wrapper${
                className != null ? ` ${className}` : ``
            }`}
            onClick={longPress == null ? onClick : undefined}
            {...longPress}
        >
            <div className="icon-stack">
                <InventoryItemIcon
                    bgColor={bgColor}
                    bgSrc={bgSrc}
                    iconColor={iconColor}
                    iconSrc={iconSrc}
                    forwardRef={forwardRef}
                    className="icon-img-wrapper"
                />
                {onLongClick != null && isPressing && (
                    <div className="icon-fill-box">
                        <div
                            className={
                                isPressComplete
                                    ? "fill-complete"
                                    : "fill-progress"
                            }
                            style={
                                isPressComplete
                                    ? undefined
                                    : {
                                          animationDelay: `100ms`,
                                          animationDuration: `${
                                              longClickTimeMS - 100
                                          }ms`,
                                      }
                            }
                        />
                    </div>
                )}

                {highlightColor != null && (
                    <div
                        className={`icon-highlight${
                            highlightColor !== undefined
                                ? ` ${highlightColor}`
                                : ""
                        }`}
                    />
                )}
            </div>
        </div>
    );
}
